export type RoleEnum =
  | 'admin'
  | 'user'
  | 'auditor'
  | 'it'
  | 'collaborator'
  | 'auditors_zone'
  | 'reviewer'
  | 'stakeholder_role'
  | 'trustcenter_access_manager'
  | 'contributor_role'
  | 'viewer_role';

export const RoleEnum = {
  Admin: 'admin' as RoleEnum,
  Collaborator: 'collaborator' as RoleEnum,
  Manager: 'manager' as RoleEnum,
  User: 'user' as RoleEnum,
  Auditor: 'auditor' as RoleEnum,
  It: 'it' as RoleEnum,
  Reviewer: 'reviewer' as RoleEnum,
  Stakeholder: 'stakeholder_role' as RoleEnum,
  Zone: 'auditors_zone' as RoleEnum, // This is the auditors portal (aka zone) role
  TrustCenterAccessManager: 'trustcenter_access_manager' as RoleEnum,
  Contributor: 'contributor_role' as RoleEnum,
  Viewer: 'viewer_role' as RoleEnum,
};
